import axios from "axios";
import Swal from "sweetalert2";
import userData from "@/plugins/userData";
import { FwbAlert } from "flowbite-vue";
import Highcharts from "highcharts";
import InputSelect from "@/components/forms/InputSelectProfil.vue";

export default {
  mixins: [userData],
  name: "DashboardPage",
  components: {
    FwbAlert,
    InputSelect,
  },
  data() {
    return {
      data_status: {
        jumlah_pemberkasan: 0,
        jumlah_proses_verifikasi: 0,
        jumlah_berkas_tidak_lengkap: 0,
        jumlah_pengajuan_ditolak: 0,
        jumlah_pengajuan_diterima: 0,
        jumlah_pencairan_bantuan: 0,
        jumlah_selesai: 0,
      },
      filter: {
        periode: "20251",
      },
      listPeriode: [
        { value: "20242", text: "Periode 2024 Genap" },
        { value: "20251", text: "Periode 2025 Ganjil" },
      ],
      count_mahasiswa: 0,
      count_pengajuan: 0,
      openRegister: 0,
      data_by_kec: [],
      data_by_kampus: [],
      isLoading: false,
    };
  },
  mounted() {
    this.initPeriode();
    this.fetchData();
  },
  computed: {
    listPeriodeAuto() {
      const year = new Date().getFullYear();
      return [
        { value: `${year - 1}2`, text: `Periode ${year - 1} Genap` },
        { value: `${year}1`, text: `Periode ${year} Ganjil` },
      ];
    },
  },
  methods: {
    getAutoPeriode() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;

      if (month >= 1 && month <= 6) {
        return `${year - 1}2`;
      }

      return `${year}1`;
    },
    initPeriode() {
      const autoPeriode = this.getAutoPeriode();

      // Tambah jika belum ada
      if (!this.listPeriode.some((p) => p.value === autoPeriode)) {
        const year = autoPeriode.substring(0, 4);
        const semester = autoPeriode.endsWith("1") ? "Ganjil" : "Genap";
        this.listPeriode.push({
          value: autoPeriode,
          text: `Periode ${year} ${semester}`,
        });
      }

      // Urutkan descending
      this.listPeriode.sort((a, b) => b.value.localeCompare(a.value));

      // Set default ke autoPeriode
      this.filter.periode = autoPeriode;
    },
    fetchData() {
      this.isLoading = true;
      axios
        .get("/dashboard/", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            periode: this.filter.periode,
          },
        })
        .then((response) => {
          this.count_mahasiswa = response.data.data_count_mahasiswa;
          this.count_pengajuan = response.data.data_count_pengajuan;
          this.data_by_kec = response.data.data_by_kec;
          this.data_by_kampus = response.data.data_by_kampus;
          for (let key in response.data.data_by_status) {
            this.data_status[key] = response.data.data_by_status[key];
          }
          this.fetchStatusLaunch();
          this.renderKecamatan();
          this.renderKampus();
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message;
        });
    },
    renderKecamatan() {
      Highcharts.chart(this.$refs.barKecamatan, {
        chart: {
          type: "column",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "Grafik Permohonan Bantuan Berdasarkan Kecamatan",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: "Jumlah",
          },
          labels: {
            formatter: function () {
              return this.value;
            },
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return Highcharts.numberFormat(this.y, 0, ",", ".");
              },
            },
          },
        },
        tooltip: {
          valueSuffix: " permohonan",
        },
        series: [
          {
            name: "Jumlah",
            data: this.data_by_kec.map((data) => ({
              name: data.kec,
              y: parseInt(data.jumlah),
            })),
            colorByPoint: true,
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
            },
            menuButtonTextKey: {
              viewFullscreen: "Tampilkan Layar Penuh",
            },
          },
        },
      });
    },
    renderKampus() {
      Highcharts.chart(this.$refs.barKampus, {
        chart: {
          type: "bar",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "Grafik Permohonan Bantuan Berdasarkan Asal Kampus",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: "Jumlah",
          },
          labels: {
            formatter: function () {
              return this.value;
            },
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return Highcharts.numberFormat(this.y, 0, ",", ".");
              },
            },
          },
        },
        tooltip: {
          valueSuffix: " permohonan",
        },
        series: [
          {
            name: "Jumlah",
            data: this.data_by_kampus.map((data) => ({
              name: data.kampus,
              y: parseInt(data.jumlah),
            })),
            colorByPoint: true,
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
            },
            menuButtonTextKey: {
              viewFullscreen: "Tampilkan Layar Penuh",
            },
          },
        },
      });
    },
    confirmLaunch() {
      Swal.fire({
        title: "Luncurkan Aplikasi ?",
        text: "Aplikasi akan segera aktif",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Batal",
        confirmButtonText: "Luncurkan !",
      }).then((result) => {
        if (result.value) {
          this.launchApp();
        }
      });
    },
    launchApp() {
      this.isLoading = true;
      try {
        axios
          .get(`/v1/about/launch/`, {
            headers: {
              token: this.userToken,
            },
          })
          .then((response) => {
            Swal.fire({
              title: "Sukses",
              text: response.data.message,
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK!",
            }).then(() => {
              this.isLoading = false;
              this.fetchData();
            });
          })
          .catch((error) => {
            Swal.fire({
              title: "Gagal",
              text: "Gagal Meluncurkan Aplikasi",
              icon: "error",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK!",
            }).then(() => {
              this.isLoading = false;
              this.fetchData();
            });
            this.error = error.message;
          });
      } catch (err) {
        this.isLoading = false;
        console.error(err);
      }
    },
    pauseLaunch() {
      this.isLoading = true;
      try {
        axios
          .get(`/v1/about/unlaunch/`, {
            headers: {
              token: this.userToken,
            },
          })
          .then((response) => {
            Swal.fire({
              title: "Sukses",
              text: response.data.message,
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK!",
            }).then(() => {
              this.isLoading = false;
              this.fetchData();
            });
          })
          .catch((error) => {
            Swal.fire({
              title: "Gagal",
              text: "Gagal Meluncurkan Aplikasi",
              icon: "error",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK!",
            }).then(() => {
              this.isLoading = false;
              this.fetchData();
            });
            this.error = error.message;
          });
      } catch (err) {
        this.isLoading = false;
        console.error(err);
      }
    },
    fetchStatusLaunch() {
      axios
        .get("/v1/about/")
        .then((response) => {
          this.openRegister = response.data.open_registrasi;
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message;
        });
    },
  },
};
